/**
 * Targets object generated by Goal app.
 *
 * @typedef {Object} Targets
 * @namespace
 *
 * @memberof module:Goal.Model.Entity
 *
 * @property {Number} numeric The milestone strategy.
 * @property {Date} date The overflow strategy.
 */
class Targets {

	constructor(numeric, date) {

		this.numeric = numeric;
		this.date = date;
	}
}

export default Targets;